/*
 |--------------------------------------------------------------------------
 | 会员授权相关类库，封装登录、退出、token等操作
 |--------------------------------------------------------------------------
 |
 | 将全局常量配置放置在这里，方便修改
 |
 |
 */
import constants from './constants';


export default {

  user: null,

  authenticated: false,


    autoLogin(context, creds) {
        return new Promise(function (resolve, reject) {
            let error_result = {code: "500", data: "自动登陆失败"};
            let accessToken = localStorage.getItem(constants.AUTH_TOKEN_KEY);
            if (accessToken) {
                context.$http.post(constants.API_HOST + constants.AUTO_LOGIN_URL, {token:accessToken}).then((result) => {
                    let data = result.data;
                    if (data.code === "200") {
                        localStorage.setItem(constants.AUTH_TOKEN_KEY, data.data.access_token);
                        localStorage.setItem(constants.AUTH_USER_KEY, JSON.stringify(data.data.user));
                        this.authenticated = true;
                        this.user = data.data.user;
                        resolve(data);
                    } else {
                        reject(data);
                    }

                }, (error) => {
                    reject(error_result);
                });
            } else {
                reject(error_result);
            }
        }.bind(this));
    },
    login(context, creds) {

        return new Promise(function (resolve, reject) {
            let error_result = {code: "500", data: "登陆失败"};
            context.$http.post(constants.API_HOST + constants.LOGIN_URL, creds).then((result) => {
                let data = result.data;
                if (data.code === "200") {
                    localStorage.setItem(constants.AUTH_TOKEN_KEY, data.data.access_token);
                    localStorage.setItem(constants.AUTH_USER_KEY, JSON.stringify(data.data.user));
                    this.authenticated = true;
                    this.user = data.data.user;
                    resolve(data);
                } else {
                    reject(data);
                }

            }, (error) => {
                reject(error_result);
            });

        }.bind(this));

    },
    logouted(context) {

      return new Promise(function (resolve, reject) {
        context.$http.post(constants.API_HOST  +  constants.LOGOUT_URL).then((result)=> {
          let data = result.data;
          if (data.code === "200") {
            localStorage.removeItem(constants.AUTH_TOKEN_KEY);
            localStorage.removeItem(constants.AUTH_USER_KEY);
            this.authenticated = false;
            this.user = null;
            resolve();
          } else {
            reject();
          }
        }, (error)=> {
          reject(error);
        });

      }.bind(this));

    },

  logout(context) {

    return new Promise(function (resolve, reject) {
      context.$http.post(constants.API_HOST  +  constants.LOGOUT_URL).then((result)=> {
        let data = result.data;
        if (data.code === "200") {
          localStorage.removeItem(constants.AUTH_TOKEN_KEY);
          localStorage.removeItem(constants.AUTH_USER_KEY);
          this.authenticated = false;
          this.user = null;
          resolve();
        } else {
          reject();
        }
      }, (error)=> {
        reject(error);
      });

    }.bind(this));

  },

  checkAuth() {
    let token = localStorage.getItem(constants.AUTH_TOKEN_KEY);
    if (token) {
      this.authenticated = true;
    } else {
      this.authenticated = false;
    }
  },

  getToken() {
    return localStorage.getItem(constants.AUTH_TOKEN_KEY);
  }
};



// WEBPACK FOOTER //
// ./src/lib/auth.js